// Lib Imports
import axios from 'axios';

// Core imports
import GraniteError from 'granite-admin/utils/granite-error';
import GraniteAPIClient from 'granite-admin/utils/granite-client';
import NotificationEntity from 'granite-admin/common/entities/notification';
import NotificationTemplateEntity from 'granite-admin/common/entities/notificationTemplate';
import NotificationConfigsEntity from 'granite-admin/common/entities/notificationConfigs';
import { env } from 'granite-admin/env';
const url = env.REACT_APP_GRANITE_BASE_URL || process.env.REACT_APP_GRANITE_BASE_URL;
const previewUrl = env.REACT_APP_PREVIEW_API_URL || process.env.REACT_APP_PREVIEW_API_URL;
async function fetchNotifications(page, is_read) {
  try {
    const payload = {
      params: {
        page,
        is_read
      }
    };
    const {
      data
    } = await GraniteAPIClient().get(`/notifications/`, payload);
    const list = data.results.map(item => new NotificationEntity(item));
    return {
      list,
      nextPage: data.next_page
    };
  } catch (err) {
    console.log(err);
    throw new GraniteError(err.errors);
  }
}
async function fetchNotificationsTemplate(organisation, params) {
  // const headers = { organisation };
  const payload = {
    params: {
      ...params
    }
  };
  try {
    const {
      data
    } = await GraniteAPIClient(url).get(`/notification-template/`, payload);
    const list = data.results.map(item => new NotificationTemplateEntity(item));
    return {
      list,
      count: data.count,
      nextPage: data.next_page
    };
  } catch (err) {
    console.log(err);
    throw new GraniteError(err.errors);
  }
}
async function getNotificationHandler({
  organisationId,
  id
}) {
  try {
    const {
      data
    } = await GraniteAPIClient(url).get(`/notification-template/${id}/`);
    return data;
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function referencedWorkflow(id) {
  try {
    const {
      data
    } = await GraniteAPIClient(url).get(`/notification-template/referenced-workflow/${id}/`);
    return data;
  } catch (error) {
    throw new GraniteError(error.errors);
  }
}
async function postNotificationHandler(params) {
  const payload = {
    params: {
      ...params.values
    }
  };
  // const { organisationId } = params;
  try {
    if (params.values.pk) {
      const {
        data
      } = await GraniteAPIClient(url).put(`/notification-template/${params.values.pk}/`, payload.params);
      return data;
    } else {
      const {
        data
      } = await GraniteAPIClient(url).post('/notification-template/', payload.params);
      return data;
    }
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function postOverriddenTemplateHandler(params) {
  const payload = {
    params: {
      ...params
    }
  };
  try {
    const {
      data
    } = await GraniteAPIClient(url).post('/notification-template-override/', payload.params);
    return data;
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function fetchNotificationCount() {
  try {
    const {
      data
    } = await GraniteAPIClient().get('notifications/count/?read=false');
    return data;
  } catch (err) {
    console.log(err);
    throw new GraniteError(err.errors);
  }
}
async function markRead(pk) {
  try {
    const data = await GraniteAPIClient().put(`/notifications/${pk}/`);
    return data;
  } catch (err) {
    console.log(err);
    throw new GraniteError(err.errors);
  }
}
async function markAllRead() {
  try {
    const data = await GraniteAPIClient().post(`/notifications/read/`);
    return data;
  } catch (err) {
    console.log(err);
    throw new GraniteError(err.errors);
  }
}
async function getNotificationAssetUrl(filename) {
  const payload = {
    params: {
      filename
    }
  };
  try {
    const {
      data
    } = await GraniteAPIClient().get('/document/public/upload/', payload);
    return data;
  } catch (err) {
    console.log(err);
    throw new GraniteError(err);
  }
}
async function uploadNotificationAsset(url, formData) {
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  };
  try {
    await axios.post(url, formData, config);
  } catch (err) {
    console.log(err);
    throw new GraniteError(err);
  }
}
async function previewTemplate(content) {
  try {
    const payload = {
      data: content
    };
    const data = fetch(previewUrl, {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(res => res.arrayBuffer());
    return data;
  } catch (err) {
    throw new GraniteError(err.errors);
  }
}
async function fetchNotificationConfigs(params) {
  try {
    const payload = {
      params: {
        ...params
      }
    };
    const {
      data
    } = await GraniteAPIClient().get(`/transition-notification-configs/`, payload);
    const list = data.results.map(item => new NotificationConfigsEntity(item));
    return {
      list,
      count: data.count
    };
  } catch (err) {
    throw new GraniteError(err.errors);
  }
}
async function saveNotificationConfigs(payload) {
  payload = {
    ...new NotificationConfigsEntity().mapToSnakeCase(payload)
  };
  try {
    if (payload.pk) {
      const {
        data
      } = await GraniteAPIClient(url).put(`/transition-notification-configs/${payload.pk}/`, payload);
      return new NotificationConfigsEntity(data);
    } else {
      const {
        data
      } = await GraniteAPIClient(url).post('/transition-notification-configs/', payload);
      return new NotificationConfigsEntity(data);
    }
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function deleteNotificationConfig(configPk) {
  try {
    const {
      data
    } = await GraniteAPIClient(url).delete(`/transition-notification-configs/${configPk}/`);
    return data;
  } catch (error) {
    throw new GraniteError(error);
  }
}
export { fetchNotifications, fetchNotificationCount, markRead, markAllRead, fetchNotificationsTemplate, getNotificationHandler, postNotificationHandler, postOverriddenTemplateHandler, getNotificationAssetUrl, uploadNotificationAsset, previewTemplate, fetchNotificationConfigs, saveNotificationConfigs, deleteNotificationConfig, referencedWorkflow };